module.exports = __webpack_public_path__ + "img/emoji-dizzy.f39a8bd3.svg";